<div class="content-container">
    <br />
    <div class="flex-direction-horizontal">
        <div>
            <app-image srcPath="{{ appService.loggedSession.avatarUri }}" isApiImage="false" className="app-image-medium app-image-circle"></app-image>
        </div>
        <div class="flex-direction-vertical flex-container-basic">
            <mat-form-field appearance="outline">
                <mat-label>First Name</mat-label>
                <input matInput name="FirstName" placeholder="First Name" />
            </mat-form-field>
            <br />
            <mat-form-field appearance="outline">
                <mat-label>Last Name</mat-label>
                <input matInput name="LastName" placeholder="Last Name" />
            </mat-form-field>
        </div>
    </div>
    <br />
    <div class="_peeker" style="background-color: #e6ffe6;background-color: transparent;height: 148px;margin-left: 18px;margin-right: 18px;width: fit-content;max-width: 50%;">
        <div class="flex-direction-horizontal">
            <div>
                <button mat-button style="height: 148px;">
                    <mat-icon class="material-symbols-outlined">
                        chevron_left
                    </mat-icon>
                </button>
            </div>
            <span style="display: flex; flex-direction: row; overflow-x: auto; overflow-y: hidden;max-width: 400px;width: 400px;">
                <span *ngFor="let featuredResource of featuredResources" mat-button class="button-large peek-tile" style="min-width: 118px;">
                    <app-image srcPath="{{ featuredResource.AvatarBlobPath }}" isApiImage="true" className="app-image-small app-image-circle"></app-image>
                    <div>{{ featuredResource.FirstName }} {{ featuredResource.LastName }}</div>
                    <span class="material-symbols-outlined cloaked-button">
                        trending_up
                    </span>
                    <span class="material-symbols-outlined cloaked-button">
                        lightbulb
                    </span>
                    <span class="material-symbols-outlined cloaked-button" [matMenuTriggerFor]="menu">
                        more_horiz
                    </span>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="editResource(featuredResource.ResourceId)">
                            <mat-icon class="material-symbols-outlined button-icon">edit</mat-icon>
                            <span>Edit {{ featuredResource.FirstName }} {{ featuredResource.LastName }}</span>
                        </button>
                        <button mat-menu-item (click)="editResource(featuredResource.ResourceId)">
                            <mat-icon class="material-symbols-outlined button-icon">
                                podium
                            </mat-icon>
                            <span>Schedule Audition</span>
                        </button>
                        <button mat-menu-item (click)="editResource(featuredResource.ResourceId)">
                            <mat-icon class="material-symbols-outlined button-icon">
                                movie_edit
                            </mat-icon>
                            <span>View and Edit Productions</span>
                        </button>
                    </mat-menu>
                </span>
            </span>
            <span mat-button class="button-large" (click)="appService.navigateTo('resource/0', '')" mat-button class="button-large peek-tile" style="min-width: 118px;">
                <app-image srcPath="/assets/tst-pattern.jpg" className="app-image-small app-image-circle"></app-image>
                <div>NEW RESOURCE</div>
                <span class="material-symbols-outlined cloaked-button">
                    add
                </span>
            </span>
            <div>
                <button mat-button style="height: 148px;">
                    <mat-icon class="material-symbols-outlined">
                        chevron_right
                    </mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
